import React, { useEffect, useState } from "react";
import "./profileInformation.scss";
import { Link, NavLink, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PractoceLocation from "../../practice-details/PracticeLocation";
import { fetchProviderInformation } from "../../../store/ProviderInfo/ProviderOverviewActions";
import ProviderStatus from "./ProviderStatus";
import { fetchProviderStatus } from "../../../store/Status/ProviderStatusActions";

const ProfileInformation = () => {
  const [selectedTab, setSelectedTab] = useState("info");

  const dispatch = useDispatch();
  const { isProviderOverviewDataLoading, providerOverviewData } = useSelector(
    (state) => state.providerOverviewInformation
  );

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const locationData = location.pathname.split("/");
  const providerId = locationData[2];
  const fromPracticeProvidersListPage = searchParams.get("fromPractice");

  useEffect(() => {
    setSelectedTab(locationData[4]);
    dispatch(fetchProviderInformation(providerId));
  }, []);

  useEffect(()=>{
        dispatch(fetchProviderStatus(providerId))
  },[dispatch,providerId])

  return (
    <div className="profile-information">
      <div className="container-fluid main-container main-wrapper">
        {/* SIDE BAR SECTION START */}
        <div className="sidebar-container sidebar-container-provider">
          <PractoceLocation providerId={providerId} />
        </div>
        {/* SIDE BAR SECTION END */}
        {/* MAIN SECTION START */}
        <div id="provider-main" className="flush-padding col-md-9">
          <div className="main-info main-info-profile">
            {fromPracticeProvidersListPage ? (
              <p className="proivder-prev-nav-link">
                <Link to={`/practice/${fromPracticeProvidersListPage}/profile-information/provider`}>Providers</Link>&gt;{" "}
                {[
                  providerOverviewData?.firstName,
                  providerOverviewData?.middleName,
                  providerOverviewData?.lastName,
                  providerOverviewData.suffix,
                ].join(" ")}
              </p>
            ) : (
              null
            )}
            <span className="status-section pull-right">
              <span>
                <ProviderStatus />
                {/* // Status: ON */}
              </span>
            </span>
            {isProviderOverviewDataLoading ? (
              <div>Loading ... </div>
            ) : (
              <h2 className="info-section-header text-uppercase provider-title">
                {[
                  providerOverviewData?.firstName,
                  providerOverviewData?.middleName,
                  providerOverviewData?.lastName,
                  providerOverviewData.suffix,
                ].join(" ")}
              </h2>
            )}
            <nav>
              <ul id="practice-profile-tabs" className="list-inline">
                <li
                  className={`${selectedTab === "info" && "selected"}`}
                  onClick={() => {
                    setSelectedTab("info");
                  }}
                >
                  <NavLink
                    to={`/provider/${providerId}/profile-information/info${fromPracticeProvidersListPage ? `?fromPractice=${fromPracticeProvidersListPage}` : ''}`}
                    // to="/providers/profileinformation/info"
                  >
                    Provider Info
                  </NavLink>
                </li>
                <li
                  className={`${selectedTab === "photos" && "selected"}`}
                  onClick={() => {
                    setSelectedTab("photos");
                  }}
                >
                  <NavLink
                    to={`/provider/${providerId}/profile-information/photos${fromPracticeProvidersListPage ? `?fromPractice=${fromPracticeProvidersListPage}` : ''}`}
                    // to="/providers/profileinformation/photos"
                  >
                    Photos
                  </NavLink>
                </li>
                <li
                  className={`${selectedTab === "license" && "selected"}`}
                  onClick={() => {
                    setSelectedTab("license");
                  }}
                >
                  <NavLink
                    // to="/providers/profileinformation/license"
                    to={`/provider/${providerId}/profile-information/license${fromPracticeProvidersListPage ? `?fromPractice=${fromPracticeProvidersListPage}` : ''}`}
                  >
                    License
                  </NavLink>
                </li>
                <li
                  className={`${selectedTab === "experience" && "selected"}`}
                  onClick={() => {
                    setSelectedTab("experience");
                  }}
                >
                  <NavLink
                    // to="/providers/profileinformation/experience"
                    to={`/provider/${providerId}/profile-information/experience${fromPracticeProvidersListPage ? `?fromPractice=${fromPracticeProvidersListPage}` : ''}`}
                  >
                    Experience
                  </NavLink>
                </li>
                <li
                  className={`${selectedTab === "location" && "selected"}`}
                  onClick={() => {
                    setSelectedTab("location");
                  }}
                >
                  <NavLink
                    // to="/providers/profileinformation/location"
                    to={`/provider/${providerId}/profile-information/location${fromPracticeProvidersListPage ? `?fromPractice=${fromPracticeProvidersListPage}` : ''}`}
                  >
                    Locations
                  </NavLink>
                </li>
              </ul>
            </nav>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileInformation;
